module.exports = __webpack_public_path__ + "static/media/sistemaPegar12.6bfb0068.jpg";